<template>
  <v-row justify="center">
    <alert :data="errorData" :active="activeAlert" :colorAlert="colorAlert" @dialog:change="eventdialog" />
    <v-btn class="accent shadow-4 px-8" large rounded @click.stop="dialog = true">Añadir Cliente</v-btn>

    <v-dialog v-model="dialog" persistent max-width="768">
      <ValidationObserver ref="obs" v-slot="{ passes }">
        <v-card>
          <v-progress-linear v-if="loading" indeterminate color="primary" rounded height="6"></v-progress-linear>

          <v-card-title class="pa-0 shadow-1">
            <v-img
              :src="require('@/assets/illustrations/bg_modal_card.svg')"
              cover
              position="left bottom"
              class="align-center"
              height="65px"
            >
              <v-card-title class="font-weight-medium primary--text">
                Nuevo cliente
              </v-card-title>
            </v-img>
          </v-card-title>

          <vuescroll
            :ops="{
              bar: { background: '#bacfcec0', keepShow: true },
            }"
          >
            <v-card-text :style="`max-height: ${DIALOG_MAX_HEIGHT}`">
              <v-form>
                <v-row dense>
                  <v-col cols="12">
                    <ValidationProvider name="nombre" rules="required" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Nombre"
                        name="nombre"
                        prepend-inner-icon="mdi-account"
                        type="text"
                        color="blue-grey"
                        v-model="ClientName"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="usuario" rules="required" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Usuario"
                        name="usuario"
                        prepend-inner-icon="mdi-account"
                        color="blue-grey"
                        v-model="ClientUser"
                        :error-messages="errors"
                        @click:append="showPassword = !showPassword"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="correo electrónico" rules="email|required" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Correo electrónico"
                        name="email"
                        prepend-inner-icon="mdi-account"
                        type="text"
                        color="blue-grey"
                        v-model="ClientEmail"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="contraseña" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Contraseña"
                        name="password"
                        prepend-inner-icon="mdi-lock"
                        :append-icon="showPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                        :type="showPassword ? 'text' : 'password'"
                        color="blue-grey"
                        v-model="ClientPassword"
                        :error-messages="errors"
                        @click:append="showPassword = !showPassword"
                      ></v-text-field>
                    </ValidationProvider>

                    <v-slide-y-transition>
                      <p v-if="ClientPassword" class="grey--text caption pb-3">
                        <v-icon small left color="blue-grey">mdi-information</v-icon>Recuerde anotar la contraseña para
                        entregársela al usuario.
                      </p>
                    </v-slide-y-transition>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider name="Cantidad de Agentes" rules="numeric" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Cantidad de Agentes"
                        name="password"
                        prepend-inner-icon="mdi-account"
                        color="blue-grey"
                        v-model="agent"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider name="Cantidad de Supervisores" rules="numeric" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Cantidad de Supervisores"
                        name="supervisor"
                        prepend-inner-icon="mdi-account-arrow-up"
                        color="blue-grey"
                        v-model="supervisor"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                  <v-col cols="12">
                    <ValidationProvider name="Plan" rules="required" v-slot="{ errors }">
                      <v-select
                        :items="[
                          { id: 1, name: 'Plan Pro' },
                          { id: 2, name: 'Plan Básico' },
                          { id: 3, name: 'Plan Demo' },
                        ]"
                        item-text="name"
                        item-value="id"
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Plan"
                        name="Plan"
                        prepend-inner-icon="mdi-crop-landscape"
                        color="blue-grey"
                        v-model="plan_id"
                        :error-messages="errors"
                      ></v-select>
                    </ValidationProvider>
                  </v-col>

                  <!-- Has Signature -->
                  <v-col cols="12">
                    <ValidationProvider name="Tiene firma?" rules="required">
                      <v-switch
                        class="ml-3"
                        color="success"
                        v-model="has_signature"
                        inset
                        label="Tiene firma"
                      ></v-switch>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="IP de grabación" rules="required" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="IP de grabación"
                        name="ip_recording"
                        prepend-inner-icon="mdi-microphone"
                        color="blue-grey"
                        v-model="ip_recording"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="dirección IP" rules="required" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Dirección IP"
                        name="ip"
                        prepend-inner-icon="mdi-web"
                        color="blue-grey"
                        v-model="ClientIP"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="nombre de BD" rules="required" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Nombre de BD"
                        name="nameBd"
                        prepend-inner-icon="mdi-database"
                        color="blue-grey"
                        v-model="ClientNameBd"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="puerto de BD" rules="required" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Puerto de BD"
                        name="portBd"
                        prepend-inner-icon="mdi-network"
                        color="blue-grey"
                        v-model="ClientPort"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>

                <v-card-title class="font-weight-medium primary--text">
                  Configuración de socket
                </v-card-title>
                <v-row dense>
                  <v-col cols="12">
                    <ValidationProvider name="usuario_sokect" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Usuario"
                        name="usuario_sokect"
                        prepend-inner-icon="mdi-account"
                        color="blue-grey"
                        v-model="user_sokect"
                        :error-messages="errors"
                        @click:append="showPassword = !showPassword"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="contraseñas_sokect" v-slot="{ errors }">
                      <v-text-field
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Contraseña"
                        name="password"
                        prepend-inner-icon="mdi-lock"
                        :append-icon="showPassword ? 'mdi-eye-outline' : 'mdi-eye-off-outline'"
                        :type="showPassword ? 'text' : 'password'"
                        color="blue-grey"
                        v-model="clave_sokect"
                        :error-messages="errors"
                        @click:append="showPassword = !showPassword"
                      ></v-text-field>
                    </ValidationProvider>

                    <v-slide-y-transition>
                      <p v-if="clave_sokect" class="grey--text caption pb-3">
                        <v-icon small left color="blue-grey">mdi-information</v-icon>Recuerde anotar la contraseña para
                        entregársela al usuario.
                      </p>
                    </v-slide-y-transition>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="dirección IP sokect" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Dirección IP"
                        name="ip_socket"
                        prepend-inner-icon="mdi-web"
                        color="blue-grey"
                        v-model="ip_sokect"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="puerto_sokect" v-slot="{ errors }">
                      <v-text-field
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Puerto"
                        value="5038"
                        name="port"
                        prepend-inner-icon="mdi-network"
                        color="blue-grey"
                        v-model="port_sokect"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>

                <v-card-title class="font-weight-medium primary--text">
                  Avanzado
                </v-card-title>
                <v-row dense>
                  <v-col cols="12">
                    <ValidationProvider name="URL del Web Socket" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="URL del Web Socket"
                        name="web_socket_server-url"
                        prepend-inner-icon="mdi-link"
                        color="blue-grey"
                        v-model="web_socket_server_url"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="Dominio de bitrix" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Dominio de bitrix"
                        name="domain_bitrix"
                        prepend-inner-icon="mdi-domain"
                        color="blue-grey"
                        v-model="domain_bitrix"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>

                  <v-col cols="12">
                    <ValidationProvider name="Clave de bitrix" v-slot="{ errors }">
                      <v-text-field
                        required
                        filled
                        rounded
                        class="rounded-small"
                        dense
                        label="Clave de bitrix"
                        name="key_bitrix"
                        prepend-inner-icon="mdi-key"
                        color="blue-grey"
                        v-model="key_bitrix"
                        :error-messages="errors"
                      ></v-text-field>
                    </ValidationProvider>
                  </v-col>
                </v-row>

                <v-card-title class="font-weight-medium primary--text">
                  Jornada
                </v-card-title>

                <v-row>
                  <v-col cols="12">
                    <ValidationProvider name="Jornada">
                      <journal-select @data:change="handleJournalChange"></journal-select>
                    </ValidationProvider>
                  </v-col>
                </v-row>
              </v-form>
            </v-card-text>
          </vuescroll>

          <v-divider></v-divider>

          <v-card-actions class="mx-2">
            <v-spacer></v-spacer>
            <v-hover v-slot:default="{ hover }">
              <v-btn text rounded class="mr-1" :color="hover ? 'error' : 'grey'" @click="dialog = false"
                >Cancelar</v-btn
              >
            </v-hover>

            <v-hover v-slot:default="{ hover }">
              <v-btn
                rounded
                :loading="loading"
                :disabled="loading"
                color="success"
                :class="hover ? 'shadow-2' : 'shadow-4'"
                class="px-8"
                @click="passes(sendform)"
                >Añadir</v-btn
              >
            </v-hover>
          </v-card-actions>
        </v-card>
      </ValidationObserver>
    </v-dialog>
  </v-row>
</template>

<script>
import vuescroll from "vuescroll";

import alert from "../Utils/Alert";
import JournalSelect from "./Journal/JournalSelect.vue";
import { defaultJournal } from "./utils";
import { DIALOG_MAX_HEIGHT } from "@/utils";

export default {
  components: {
    alert,
    vuescroll,
    JournalSelect,
  },
  data() {
    return {
      DIALOG_MAX_HEIGHT,
      showPassword: false,
      dialog: false,
      loading: false,
      ClientName: "",
      ClientUser: "",
      ClientPassword: "",
      ClientEmail: "user@pbxberry.com",
      ClientIP: "10.254.0.0",
      ip_recording: "10.254.0.0",
      ClientNameBd: "asteriskcdrdb",
      ClientPort: "3306",
      ip_sokect: "",
      user_sokect: "",
      clave_sokect: "",
      port_sokect: "",
      errorData: "",
      activeAlert: false,
      colorAlert: "",
      plan_id: null,
      agent: null,
      supervisor: null,
      key_bitrix: "",
      domain_bitrix: "",
      web_socket_server_url: "",
      has_signature: false,
      journal: defaultJournal,
    };
  },

  methods: {
    resetform() {
      this.ClientName = "";
      this.ClientUser = "";
      this.ClientPassword = "";
      this.ClientEmail = "";
      this.ClientIP = "";
      this.ip_recording = "";
      this.ClientNameBd = "";
      this.ClientPort = "";
      this.ip_sokect = "";
      this.user_sokect = "";
      this.clave_sokect = "";
      this.port_sokect = "";
      this.web_socket_server_url = "";
      this.domain_bitrix = "";
      this.key_bitrix = "";
      this.has_signature = false;
      this.journal = defaultJournal;
    },

    async sendform() {
      try {
        this.loading = true;
        const enviar = {
          ClientName: this.ClientName,
          ClientUser: this.ClientUser,
          ClientPassword: this.ClientPassword,
          ClientEmail: this.ClientEmail,
          ClientIP: this.ClientIP,
          ip_recording: this.ip_recording,
          ClientNameBd: this.ClientNameBd,
          ClientPort: this.ClientPort,
          ip_sokect: this.ip_sokect,
          user_sokect: this.user_sokect,
          clave_sokect: this.clave_sokect,
          port_sokect: this.port_sokect,
          agent: Number(this.agent),
          supervisor: Number(this.supervisor),
          plan_id: this.plan_id,
          web_socket_server_url: this.web_socket_server_url,
          domain_bitrix: this.domain_bitrix,
          key_bitrix: this.key_bitrix,
          has_signature: this.has_signature,
          journal: JSON.stringify(this.journal),
        };
        await this.$store.dispatch("clients/REGISTER_CLIENTS", enviar);
        this.$snotify.success("Cliente creado con éxito.", "¡Hecho!");
        this.loading = false;
        this.dialogVisible = false;
        this.resetform();
      } catch (error) {
        this.$snotify.error(error.response.data, "¡Error!");
        // this.errorData = error.response.data;
        // this.activeAlert = true;
        // this.colorAlert = "red";
        this.loading = false;
      }
    },

    handleJournalChange(newData) {
      this.journal = { ...newData };
    },

    eventdialog() {
      this.activeAlert = false;
    },
  },
};
</script>
